import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f216e56"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "mt-5 py-3",
  style: {"background":"#B8C1CC"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center animated animatedFadeInUp fadeInUp" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "u-align-center u-text u-text-1 animated-box my-5" }, "Sản phẩm bán chạy")
], -1))
const _hoisted_3 = { class: "my-5" }
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Slide = _resolveComponent("Slide", true)!
  const _component_Navigation = _resolveComponent("Navigation")!
  const _component_Carousel = _resolveComponent("Carousel")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_router_link, { to: "/san-pham" }, {
        default: _withCtx(() => [
          _createVNode(_component_Carousel, {
            autoplay: 2000,
            "wrap-around": true,
            settings: _ctx.settings,
            breakpoints: _ctx.breakpoints
          }, {
            addons: _withCtx(() => [
              _createVNode(_component_Navigation)
            ]),
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (item, index) => {
                return (_openBlock(), _createBlock(_component_Slide, { key: index }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: 'https://qdbakeryapi.onrender.com/api/file/' + item.imageUrl + '/view',
                      style: {"border-radius":"5px","height":"100%","width":"100%"}
                    }, null, 8, _hoisted_4)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["settings", "breakpoints"])
        ]),
        _: 1
      })
    ])
  ]))
}